import React from "react";
import classNames from "classnames";

export default function Item({ item, choosen, onClick, linkmap, labels, width, height, color }) {
  const _choosen = choosen && item.id === choosen.id;
  const incomming = !_choosen && choosen && linkmap[`${choosen.id}-${item.id}`]
  const outgoing = !_choosen && choosen && linkmap[`${item.id}-${choosen.id}`]
  const both = incomming && outgoing
  return (
    <div
      className={classNames('card-item', { choosen: _choosen, incomming, outgoing, both })}
      style={{
        '--itemColor': color || item.color,
        minHeight: `${height}px`,
        width: `${width}px`,
      }}
      data-id={item.id}
      onClick={onClick}
    >
      <div
        className={classNames("card-name")}
        style={{
          height: `${Math.max(height, 61)}px`,
        }}        
      >
        {labels.map(label => <p key={label}>{item[label]}</p>)}
      </div>
    </div>
  );
}
